<template>
    <div
        class="md-market-trends fashion"
        :class="{ mobile: isMobileSize }"
        :style="{ marginBottom }"
        v-if="showThisModule"
    >
        <div class="container">
            <module-box noPadding noMargin>
                <!-- title -->
                <div class="title_container">
                    <div v-if="marketTitle" class="mg-title" v-html="formatFontSize(marketTitle, '--mg-title-size')"></div>
                    <!-- <div class="timeline">{{ timeline }}</div> -->
                </div>
                <div
                    class="filter-chart-container module_box"
                    v-show="!showNoData"
                >
                    <div class="trends-filter" v-if="!showLock">
                        <Select
                            class="sales-price"
                            :options="priceOptions"
                            :hide_name="true"
                            :value="priceType"
                            @change="changeFilterPrice"
                        ></Select>
                        <!-- Sold Number label -->
                        <div>
                            <span class="sold-number">{{
                                $t('md-market-trends.soldNumber')
                            }}</span>
                        </div>
                    </div>
                    <site-img
                        v-if="showLock"
                        alt="market trend sample"
                        src="https://cdn.chime.me/image/fs/sitebuild/2023526/0/original_229da156-cd26-4a55-949c-59b1e4f74ddd.png"
                    ></site-img>
                    <echart
                        v-if="!showLock"
                        :ref="onEchartRef"
                        class="chart-box"
                        :options="chartOption"
                        :notMerge="true"
                    >
                    </echart>
                    <div class="lock-container" v-if="showLock">
                        <div class="box">
                            <div class="lock-icon">
                                <span
                                    class="iconfont icon-circle-lock"
                                    @click="showRegisterPop"
                                ></span>
                            </div>
                            <div
                                class="avg-diff-text"
                                v-html="avgDiffText"
                            ></div>
                            <div class="desc" @click="showRegisterPop">
                                {{ TEXT.unlockDesc }}
                                <i class="iconfont icon-chevron_right"></i>
                            </div>
                        </div>
                    </div>
                    <p v-if="!showLock" class="mls-desc-tip">
                        <span class="iconfont icon-local2"></span>
                        {{ TEXT.mlsDesc }}
                    </p>
                </div>
                <div class="no_data module_box" v-show="showNoData">
                    <img
                        class="pic"
                        src="//static.chimeroi.com/image/market-trends/blank-v4@2x.png"
                        :alt="$t('md-market-trends.noData')"
                    />
                    <div class="desc">{{ TEXT.noDataDesc }}</div>
                </div>
                <!--  Non-login state  -->
                <template v-if="cmpCheckMoreBtn || isInsight">
                    <div class="cta-btn" :class="{ disable: showNoData }">
                        <im-popper
                            :disabled="!showNoData"
                            :hover="true"
                            placement="top"
                            :offset="[0, 20]"
                            ref="tooltip"
                        >
                            <template v-slot:reference>
                                <button
                                    :style="checkMoreBtnStyle"
                                    v-html="
                                        isInsight
                                            ? defaultCheckMoreBtn
                                            : cmpCheckMoreBtn
                                    "
                                    @click="clickCheckMoreBtn"
                                ></button>
                            </template>
                        </im-popper>
                    </div>
                </template>
            </module-box>
        </div>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    data: function() {
        return {
            theme: 'fashion'
        };
    },
    methods: {}
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
@import '.././chart.scss';
.md-market-trends.fashion {
    .container {
        width: 100%;
        background-color: #f5f6fa;
        padding: 40px 0;
        @media (max-width: 600px) {
            padding: 20px 0;
        }
    }
    .title_container {
        padding-bottom: 30px;
        .mg-title {
            width: auto;
            margin: 0;
            padding-bottom: 0;
            margin-right: 10px;
            .zipcode {
                color: var(--color-label);
                font-size: 12px;
                padding-left: 10px;
                font-family: var(--font-medium);
            }
        }
        .timeline {
            color: #a0a3af;
            font-size: 14px;
            font-family: var(--font-normal);
        }
    }

    .filter-chart-container {
        position: relative;
        display: flex;
        flex-direction: column;
        > img {
            object-fit: contain;
            width: 100%;
            height: 100%;
        }
        .trends-filter {
            height: 50px;
            color: var(--color-label);
            display: flex;
            justify-content: flex-end;
            font-family: var(--font-medium);
            > .select {
                position: relative;
                .box-div {
                    position: relative;
                    &:before {
                        content: '';
                        width: 12px;
                        height: 4px;
                        position: absolute;
                        top: 50%;
                        background: #4c84ff;
                        transform: translateY(-50%);
                        left: -22px;
                    }
                }
                .title {
                    width: 100%;
                    display: flex;
                    overflow: hidden;
                    cursor: pointer;
                    .text {
                        flex: 1;
                        @include ellipsis();
                        cursor: pointer;
                        margin-right: 10px;
                    }
                    .icon-arrow-down {
                        flex: none;
                        color: #c6c8d1;
                    }
                }
                .list-panel {
                    width: calc(100% + 24px);
                    position: absolute;
                    top: 100%;
                    left: -24px;
                    border: 1px solid #ebecf1;
                    z-index: 10;
                    padding: 5px 0;
                    background: #fff;
                    margin-top: 5px;
                    box-shadow: 0 3px 10px 0 rgba(170, 186, 218, 0.3);
                    li {
                        white-space: nowrap;
                        padding: 0 40px 0 10px;
                        line-height: 32px;
                        font-size: 14px;
                        color: #515666;
                        padding-left: 20px;
                        cursor: pointer;
                        &.selected {
                            @include color-theme();
                            .iconfont.icon-checked-light {
                                display: none;
                            }
                        }
                        &:not(.selected):hover {
                            @include color-theme();
                            background-color: #f3f3f3;
                        }
                    }
                }
            }
            .sales-price {
                margin-right: 72px;
            }
            .sold-number {
                position: relative;
                &:before {
                    content: '';
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    top: 50%;
                    background: #bfc5d1;
                    transform: translateY(-50%);
                    left: -22px;
                }
            }
        }
        .chart-box {
            width: 100%;
            z-index: var(--level-low);
            flex: 1;
            > div {
                z-index: 0;
            }
        }
        .lock-container {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            position: absolute;
            z-index: var(--level-low);
            top: 0;
            left: 0;
            -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
            background-color: rgba(255, 255, 255, 0.85);
            .lock-icon {
                text-align: center;
                .icon-circle-lock {
                    cursor: pointer;
                    color: var(--color-theme);
                    font-size: 60px;
                }
            }
            .avg-diff-text {
                color: #8b93a7;
                font-size: 16px;
                margin: 20px 0;
                .number {
                    font-family: var(--font-bold);
                    &.up {
                        color: #29cb97;
                    }
                    &.down {
                        color: #ff5661;
                    }
                }
            }
            .desc {
                cursor: pointer;
                font-size: 16px;
                font-family: var(--font-bold);
                color: var(--color-theme);
                text-align: center;
            }
        }
    }
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 250px;
            height: 140px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
    .module_box {
        height: 470px;
        box-sizing: border-box;
        position: relative;
        background-color: #ffffff;
        padding: 40px 51px 50px 50px;
    }
    .cta-btn {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        padding-top: 40px;
        &.disable {
            button {
                cursor: not-allowed;
            }
        }
        .im-popover {
            .popper {
                span {
                    background-color: #303133;
                    color: #fff;
                    padding: 6px 10px;
                    border-radius: 4px;
                    position: relative;
                    &::before {
                        position: absolute;
                        content: ' ';
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-style: solid;
                        bottom: -5px;
                        margin-left: 48%;
                        border-width: 5px;
                        border-top-color: #303133;
                        border-bottom-width: 0;
                    }
                }
            }
        }
        button {
            @include color-button-hover();
            font-size: 16px;
            font-family: var(--mg-button-font);
            font-weight: 500;
            padding-left: 30px;
            padding-right: 30px;
            padding-bottom: 10px;
            padding-top: 10px;
            min-width: 343px;
            min-height: 40px;
            text-align: center;
            color: var(--cta-button-color, var(--mg-button-color));
            background-color: var(
                --cta-button-bgcolor,
                var(--mg-button-background)
            );
        }
    }
    .mls-desc-tip {
        position: relative;
        z-index: var(--level-low);
        color: #c6c8d1;
        margin-top: 20px;
        .iconfont {
            margin-right: 5px;
        }
    }
}
.md-market-trends.fashion.mobile {
    .container {
        width: 100%;
        background-color: #ffffff;
    }
    .mg-title {
        /* padding-bottom: 20px; */
        width: 100%;
    }
    .module_box {
        box-shadow: none;
        padding: 0;
        height: 370px;
    }
    .mls-desc-tip {
        margin-top: 10px;
    }
    .filter-chart-container {
        .trends-filter {
            justify-content: flex-start;
            .box-div {
                margin-left: 20px;
                &:before {
                    left: -20px;
                    top: 5px;
                    transform: none;
                }
            }
            .title {
                .text {
                    margin-right: 5px;
                }
                .dropdown_icon {
                    width: 12px;
                    font-size: 12px;
                }
            }
            .list-panel {
                width: auto;
                left: -20px;
                li {
                    padding: 0 10px 0 10px;
                }
            }
        }
        .sales-price {
            margin-right: 40px;
        }
    }

    .lock-container,
    .no_data {
        .avg-diff-text,
        .desc {
            font-size: 14px;
        }
    }
    .module_box {
        height: 350px;
    }
    .cta-btn {
        padding-top: 20px;
        button {
            width: 100%;
        }
    }
}
</style>
